import { defineStore } from "pinia";
import { ref } from "vue";
import QuoteService from "@/services/QuoteService";

export const useQuoteStore = defineStore("quote", {
  state() {
    return {
      quoteId: null,
      quoteService: null,
      quoteData: ref({}),
      activeVersion: 0,
      loading: true,
    };
  },

  actions: {
    configure(quoteId) {
      this.quoteId = quoteId;
      this.quoteService = new QuoteService(this.quoteId);
      this.fetch();
    },

    async fetch() {
      try {
        this.loading = true;
        const response = await this.quoteService.get();
        this.quoteData.value = response.data?.data ?? response.data;
        this.activeVersion = 0;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async update(payload = this.data) {
      try {
        return await this.quoteService.manage(payload);
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    setCustomer(customer) {
      this.quoteData.value.customer_id = customer.id;
      this.quoteData.value.customer = customer;
    },

    setActiveVersion(versionIndex) {
      this.activeVersion = versionIndex;
    },
  },

  getters: {
    isLoading() {
      return this.loading;
    },

    id() {
      return this.quoteId;
    },

    data() {
      return this.quoteData.value;
    },

    name() {
      return (
        this.quoteData.value?.reference?.name ||
        this.quoteData.value?.display_name ||
        this.quoteData.value?.description ||
        "Quote"
      );
    },

    activeVersionData() {
      return this.quoteData.value?.versions?.[this.activeVersion];
    },
  },
});
